<!--
    @负责人: libaiiq
    @创建时间: 2018-09-05
    @版本:v1.0.22
    @描述: 资源实例
    -->
<template>
  <div class="repertoryInstance__content">
    <g-back :history="history"></g-back>
    <div class="repertoryInstance__form">
      <el-form ref="form" :model="form" :inline="true" input-width="auto">
        <el-form-item :label="item.name" v-for="(item,index) in searchList" :key="index">
          <el-input v-if="!item.sysDic" v-model="form[item.property]"></el-input>
          <el-select v-else v-model="form[item.property]" clearable >
            <el-option
              v-for="(sitem, skey) in item.value"
              :key="skey"
              :label="sitem"
              :value="skey">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="search" v-g-rac="gRac('repertotyInstance@search')" v-if="searchList.length!==0">{{ $t('common.search') }}</el-button>
          <el-button type="primary" @click="e_add(null)" v-g-rac="gRac('repertotyInstance@create')">{{ $t('repertory.createInstance') }}</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="repertoryInstance__table">
      <el-table
        :data="tData"
        border
        style="width: 100%">
        <el-table-column
        v-for="(item,index) in tableHead"
        :key="'keys'+index"
        :label="item.name"
        v-if="item.property==='bucketName'">
          <template slot-scope="scope">
            <el-button type="text" @click="toS3(scope.row)" size="small" v-text="scope.row.bucketName"></el-button>
          </template>
        </el-table-column>
        <el-table-column
          :prop="item.property"
          :label="item.name"
          v-else>
        </el-table-column>
        <el-table-column
          fixed="right"
          :label="$t('common.handle')"
          width="120px">
          <template slot-scope="scope">
            <el-button type="text" @click="e_add(scope.row)" size="small">{{ $t('common.edit') }}</el-button>
            <el-button type="text" @click="e_delete(scope.row)" size="small">{{ $t('common.delete') }}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="repertoryInstance__pager">
        <el-pagination
          background
          @size-change="e_handleSizeChange"
          @current-change="e_handleCurrentChange"
          layout="total, sizes, prev, pager, next, jumper"        
          :current-page="currentPage"
          :page-size="pageSize"
          :page-count="pageCount"
          :total="total">
        </el-pagination>
      </div>
    </div>
    <dialog-form
      key="instanceForm"
      :title="dialogTitle" 
      :size="3" 
      :label-size="2" 
      :visible.sync="dialogFormShow" 
      :model="dialogModel"
      :input-data="dialogData"
      :rules="dialogFormRule"
      :confirm-fun="isConfirmAdd">
    </dialog-form>
  </div>
</template>
<script>
  import dic from '@/components/mixins/dic'
  import table from '@/components/mixins/table'
  import rac from '@/plugins/rac-mixin.js'
  import repertoryBiz from '@/logic/cmdb/repertoryBiz.js'
  import resourceModelBiz from '@/logic/cmdb/resourceModelBiz'
  import dialogForm from '@/components/dialogForm'
  import validateConfig from '@/utils/validate'
  import { getKeyByValue } from '@/utils/tool'
  export default {
    mixins: [dic, table, rac],
    data () {
      return {
        form: {},
        history: [],
        propertyList: [],
        selectId: '',
        isAmend: false,
        searchList: [],
        // encryptProperty: [],
        instanceTitle: '',
        tableHead: [],
        tData: [],
        currentPage: 1,
        pageSize: 10,
        pageCount: 10,
        total: 0,
        dialogTitle: '',
        dialogFormShow: false,
        dialogModel: {},
        dialogFormRule: {},
        dialogData: []
      }
    },
    methods: {
      e_init () {
        this.history = []
        this.history.push({ name: decodeURI(this.$route.query.resourceName), path: '/home/repertory' })
        this.getProperty()
      },
      setDialogData () {
        this.dialogData = []
        this.dialogFormRule = {}
        this.dialogModel = {}
        this.propertyList.forEach((item) => {
          let obj = {}
          obj.key = item.property
          obj.label = item.name
          this.$set(this.dialogModel, item.property, '')
          if (item.type === 'ARRAY' || item.type === 'ENUM' || item.type === 'BOOLEAN') {
            obj.type = 'select'
            obj.select = item.value
          }
          if (item.encrypt) {
            obj.type = 'password'
          }
          if (item.require) {
            this.dialogFormRule[item.property] = [{ ...validateConfig.common.notEmpty }]
          }
          this.dialogData.push(obj)
        })
      },
      e_search () {
        let d = {
          resourceType: this.$route.query.resourceType,
          flagId: this.$route.query.flagId,
          currentPage: this.currentPage,
          perPageCount: this.pageSize,
          condition: []
        }
        Object.keys(this.form).forEach((item) => {
          let obj = {}
          if (this.form[item] !== '') {
            obj[item] = this.form[item]
            d.condition.push(obj)
          }
        })
        repertoryBiz.getInstance(d).then((data) => {
          this.propertyList.forEach((item) => {
            if (item.value !== '' && Object.keys(item.value).length !== 0) {
              data.dataList.forEach((d) => {
                d[item.property] = item.value[d[item.property]]
              })
            }
          })
          data.dataList.map(item => {
            for (let i in item) {
              if (typeof item[i] !== 'number' && typeof item[i] !== 'string') {
                item[i] = JSON.stringify(item[i])
              }
            }
          })
          this.tData = data.dataList
          this.total = data.totalCount
        })
      },
      e_handleSizeChange (data) {
        this.currentPage = 1
        this.pageCount = data
        this.pageSize = data
        this.e_search()
      },
      e_handleCurrentChange (data) {
        this.currentPage = data
        this.e_search()
      },
      search () {
        this.currentPage = 1
        this.e_search()
      },
      getProperty () {
        resourceModelBiz.getProperty({flagId: this.$route.query.flagId, resourceType: this.$route.query.resourceType, perPageCount: 1000}).then((d) => {
          this.tableHead = []
          this.searchList = []
          // this.encryptProperty = []
          this.propertyList = []
          this.form = {}
          d.dataList.forEach((item) => {
            let value
            let list = {}
            if ((item.type === 'ARRAY' || item.type === 'ENUM') && !item.sysDic) {
              value = item.value.split(',')
              value.forEach((i) => {
                if (i === 'true') {
                  list[i] = this.$t('repertory.yes')
                } else if (i === 'false') {
                  list[i] = this.$t('repertory.no')
                } else {
                  list[i] = i
                }
              })
              item.value = list
            }
            if ((item.type === 'ARRAY' || item.type === 'ENUM' || item.type === 'BOOLEAN') && item.sysDic) {
              this.dGetDictionaryByCode(item.value, true)
              setTimeout(() => {
                item.value = { ...this.dDictionary[item.value] }
                if (item.search) {
                  this.setDicValue(item)
                }
              }, 200)
            }
            if (item.type === 'BOOLEAN' && !item.sysDic) {
              item.value = {
                true: this.$t('repertory.yes'),
                false: this.$t('repertory.no')
              }
            }
            // if (item.encrypt) {
            //   this.encryptProperty.push(item.property)
            // }
            if (item.display) {
              if (item.search && !item.sysDic) {
                this.setDicValue(item)
              }
              this.tableHead.push(item)
            }
            this.propertyList.push(item)
          })
          setTimeout(() => {
            this.search()
            this.setDialogData()
          }, 500)
        })
      },
      setDicValue (item) {
        let obj = {}
        obj.property = item.property
        obj.name = item.name
        obj.value = item.value
        obj.sysDic = item.sysDic
        this.searchList.push(obj)
      },
      e_add (rowData) {
        this.isAmend = rowData !== null
        this.dialogTitle = rowData !== null ? this.$t('repertory.eidtInstance') : this.$t('repertory.createInstance')
        this.dialogFormShow = true
        this.selectId = rowData !== null ? rowData.id : ''
        this.propertyList.forEach((item) => {
          if (rowData !== null) {
            if (rowData[item.property] instanceof Array) {
              rowData[item.property] = Object.prototype.toString.call(rowData[item.property]) === '[object Array]' ? rowData[item.property].join(',').toString() : rowData[item.property].toString()
            }
            this.$set(this.dialogModel, item.property, Object.keys(item.value).length !== 0 ? getKeyByValue(item.value, rowData[item.property]) : rowData[item.property])
          } else {
            this.$set(this.dialogModel, item.property, '')
          }
        })
      },
      e_delete (rowData) {
        this.$confirm(this.$t('common.deleteTips'), this.$t('common.delete'), {
          confirmButtonText: this.$t('common.confirm'),
          cancelButtonText: this.$t('common.cancel'),
          type: 'warning'
        }).then(() => {
          repertoryBiz.deleteInstance({ id: rowData.id,
            resourceType: this.$route.query.resourceType,
            flagId: this.$route.query.flagId }).then(() => {
            this.$message({
              message: this.$t('common.success'),
              type: 'success'
            })
            setTimeout(() => {
              this.search()
            }, 500)
          })
        }).catch(() => {})
      },
      isConfirmAdd () {
        let data = {}
        // if (this.encryptProperty.length !== 0) {
        //   this.encryptProperty.forEach((item) => {
        //     this.dialogModel[item.property] = MD5(this.dialogModel[item.property])
        //   })
        // }
        data = {
          resourceType: this.$route.query.resourceType,
          flagId: this.$route.query.flagId,
          instance: {...this.dialogModel}
        }
        if (this.isAmend) {
          data.id = this.selectId
          repertoryBiz.updateInstance(data).then(() => {
            this.$message({
              message: this.$t('common.success'),
              type: 'success'
            })
            setTimeout(() => {
              this.dialogFormShow = false
              this.e_search()
            }, 500)
          })
        } else {
          repertoryBiz.saveInstance(data).then(() => {
            this.$message({
              message: this.$t('common.success'),
              type: 'success'
            })
            setTimeout(() => {
              this.dialogFormShow = false
              this.e_search()
            }, 500)
          })
        }
      },
      toS3 (rowData) {
        let query = {}
        query.id = rowData.id
        query.name = rowData.bucket
        query.flagId = this.$route.query.flagId
        query.resourceName = this.$route.query.resourceName
        this.$router.push({ name: 's3Record', query: query })
      }
    },
    components: {
      dialogForm
    },
    mounted () {
      this.e_init()
    },
    watch: {
      $route (newV, oldV) {
        if ((oldV.name === 'repertory' || oldV.name === 's3Record') && newV.name === 'repertoryInstance') {
          this.e_init()
        }
      }
    }
  }
</script>

<style scoped>
  .repertoryInstance__pager{
    float: right;
    margin-top: 20px;
  }   
</style>